// extracted by mini-css-extract-plugin
export default {"title01":"ReviewComplete_title01__Unipl","section01":"ReviewComplete_section01__2ovf9","section02":"ReviewComplete_section02__NkemK","infoTitle":"ReviewComplete_infoTitle__Mcysx"};